import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a wooden rocking chair: oak seat, slatted tilted back and
// armrests on a walnut frame; each rocker is two thin angled boxes meeting
// under the chair to read as a curve. Front faces +Z.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";

export const rockingChair = defineModel({
  id: "rocking-chair",
  batchId: "modern",
  name: "Rocking chair",
  tags: ["modern", "interior", "furniture", "seating", "living-room"],
  summary: "A wooden rocking chair with a slatted back.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // rockers — two angled segments per side, tips rising fore and aft
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.55), color: WALNUT, position: [-0.22, 0.05, -0.22], rotation: [0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.55), color: WALNUT, position: [-0.22, 0.05, 0.22], rotation: [-0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.55), color: WALNUT, position: [0.22, 0.05, -0.22], rotation: [0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.55), color: WALNUT, position: [0.22, 0.05, 0.22], rotation: [-0.12, 0, 0] },
      // legs from rockers to seat
      { geometry: new THREE.BoxGeometry(0.05, 0.3, 0.05), color: WALNUT, position: [-0.22, 0.21, 0.16] },
      { geometry: new THREE.BoxGeometry(0.05, 0.3, 0.05), color: WALNUT, position: [0.22, 0.21, 0.16] },
      { geometry: new THREE.BoxGeometry(0.05, 0.3, 0.05), color: WALNUT, position: [-0.22, 0.21, -0.18] },
      { geometry: new THREE.BoxGeometry(0.05, 0.3, 0.05), color: WALNUT, position: [0.22, 0.21, -0.18] },
      // seat
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.45), color: OAK, position: [0, 0.38, 0.02] },
      // back posts, tilted back
      { geometry: new THREE.BoxGeometry(0.05, 0.58, 0.05), color: OAK, position: [-0.225, 0.67, -0.245], rotation: [-0.15, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.58, 0.05), color: OAK, position: [0.225, 0.67, -0.245], rotation: [-0.15, 0, 0] },
      // horizontal back slats following the tilt
      { geometry: new THREE.BoxGeometry(0.4, 0.09, 0.04), color: WALNUT, position: [0, 0.52, -0.222], rotation: [-0.15, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.09, 0.04), color: WALNUT, position: [0, 0.72, -0.252], rotation: [-0.15, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.09, 0.04), color: WALNUT, position: [0, 0.9, -0.28], rotation: [-0.15, 0, 0] },
      // armrests on front posts
      { geometry: new THREE.BoxGeometry(0.06, 0.04, 0.4), color: OAK, position: [-0.26, 0.58, -0.02] },
      { geometry: new THREE.BoxGeometry(0.06, 0.04, 0.4), color: OAK, position: [0.26, 0.58, -0.02] },
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: WALNUT, position: [-0.26, 0.48, 0.14] },
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: WALNUT, position: [0.26, 0.48, 0.14] },
    ];
  },
  animations: [],
});
